import { TruncatedText } from '@ben/orion/truncated-text';
import { TypographyVariant } from '@ben/orion/typography';
import { forwardRef, memo } from 'react';
import styled, { css, useTheme } from 'styled-components';

interface TitleCellProps {
  title?: string;
  titleVariant?: TypographyVariant;
  subtitle?: string;
  color?: string;
  showTooltip?: boolean;
}

const TitleCell = forwardRef<HTMLDivElement, TitleCellProps>(
  ({ title, titleVariant, subtitle, color, showTooltip }, ref) => {
    const theme = useTheme();
    const defaultTitleVariant = subtitle
      ? TypographyVariant.bodyMd2
      : TypographyVariant.bodyMd1;

    return (
      <Wrapper ref={ref}>
        <TruncatedText
          variant={titleVariant ?? defaultTitleVariant}
          color={color}
          showTooltip={showTooltip}
        >
          {title}
        </TruncatedText>
        {subtitle && (
          <TruncatedText
            variant={TypographyVariant.bodySm1}
            color={theme.palette.neutral[90]}
            showTooltip={showTooltip}
          >
            {subtitle}
          </TruncatedText>
        )}
      </Wrapper>
    );
  }
);

TitleCell.displayName = 'TitleCell';

export default memo(TitleCell);

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.5)};
    min-width: 0; // Enable text truncation
  `}
`;
